const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  optionValueSelectionChange: "option-value-selection-change",
  variantChange: "variant-change",
  cartError: "cart-error",
};

window.ON_CHANGE_DEBOUNCE_TIMER = ON_CHANGE_DEBOUNCE_TIMER;
window.PUB_SUB_EVENTS = PUB_SUB_EVENTS;

/* Wellvare: Shopify cart token delen met get.wellvare.co (CheckoutChamp) voor WeTracked-matching */
(function () {
  try {
    var m = document.cookie.match(/(?:^|; )cart=([^;]*)/);
    if (m) {
      document.cookie = 'wv_cart=' + m[1] + ';domain=.wellvare.co;path=/;max-age=1209600;SameSite=Lax';
    }
  } catch (e) {}
})();
